module.exports = __webpack_public_path__ + "img/c10.97a77f2a.png";